import cardsJson from "./generated/cards.json";
export default cardsJson.cards;
